import Vue from 'vue';
import VueI18nManager from 'vue-i18n-manager';
import store from '@/store';
import router from '@/router';

import {
  GET_TRANSLATIONS
} from '@/store/action-types';

const proxy = {
  getTranslation: async () => {
    return await store.dispatch(`setting/${GET_TRANSLATIONS}`);
  }
};


Vue.use(VueI18nManager, {
  store,
  router,
  proxy,
  config: {
    defaultCode: 'ua-UA',
    languages: [
      {
        name: 'Ukranian',
        title: 'Укр',
        key: 'uk',
        code: 'ua-UA',
        urlPrefix: 'uk',
        translationKey: 'uk'
      },
      {
        name: 'English',
        title: 'Eng',
        key: 'eng',
        code: 'en-US',
        urlPrefix: 'en',
        translationKey: 'en'
      },
    ],
    translations: proxy,
  },
});
